// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";

export type FormContentProps = {
  classes?: any; // to suppress linting warnings.
  className?: string;
  children?: React.ReactNode;
}

const FormContent: React.FC<FormContentProps> = (props: FormContentProps) => {
  const { children } = props;
  const classes = withStyles.getClasses(props);

  return (
    <main className={classes.root}>
      {children}
    </main>
  );
};

const FormContentStyled = withStyles(
  FormContent, 
  (theme, props) => ({
    "root": {
      padding: theme.spacing(0, 6),
      width: 'inherit',
    }
  })
);

export default FormContentStyled;